import styled, {css} from 'styled-components';
import { Fonts, Colors } from 'common/Theme/index';
import Helpers from 'common/Theme/Helpers';

export const WrapStyle = styled.div`
  ${Helpers.css.flex};
  ${Helpers.css.flex_ac};
`;

export const IconWrapStyle = styled.div`
  margin-right: 5px;
`;

export const TextWrapStyle = styled.div`
  
`;
